import { render, staticRenderFns } from "./rel-receita-9-itens.vue?vue&type=template&id=a81fe9be&scoped=true&"
import script from "./rel-receita-9-itens.vue?vue&type=script&lang=js&"
export * from "./rel-receita-9-itens.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-9-itens.vue?vue&type=style&index=0&id=a81fe9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81fe9be",
  null
  
)

export default component.exports